module.exports = __webpack_public_path__ + "img/kids-feature.f5c686ef.jpg";